////////////////////////////////////////
// 商品詳細：サイズ表
////////////////////////////////////////

document.addEventListener('DOMContentLoaded', function() {
  var toggle = document.querySelector('.size-unit-toggle');
  if (!toggle) return;
  var sizeValues = document.querySelectorAll('.size-value');
  var CM_TO_INCH = 0.393701;
  function convertValue(cmStr, toInch) {

    if (cmStr.indexOf('~') !== -1) {
      var rangeParts = cmStr.split('~');
      return rangeParts.map(function(part) {
        var num = parseFloat(part.trim());
        if (isNaN(num)) {
          return part.trim();
        }
        return toInch
          ? (num * CM_TO_INCH).toFixed(1)
          : num.toString();
      }).join('~');
    }

    if (cmStr.indexOf('-') !== -1) {
      var hyphenParts = cmStr.split('-');
      return hyphenParts.map(function(part) {
        var num = parseFloat(part.trim());
        if (isNaN(num)) {
          return part.trim();
        }
        return toInch
          ? (num * CM_TO_INCH).toFixed(1)
          : num.toString();
      }).join('-');
    }

    var num = parseFloat(cmStr);
    if (isNaN(num)) {
      return cmStr;
    }
    return toInch
      ? (num * CM_TO_INCH).toFixed(1)
      : num.toString();
  }

  toggle.addEventListener('change', function() {
    var isInch = this.checked;
    sizeValues.forEach(function(element) {
      var cmValue = element.getAttribute('data-cm');
      element.textContent = convertValue(cmValue, isInch);
    });
  });
});